import { ReactElement } from 'react';
import { DiagramProvider } from '../../../../components';
import { LeftPanelContainer } from '../../Panels/LeftPanel/container';
import { SessionDiagramContainer } from '../../SessionDiagram/container';

export type TopologyTabContentProps = {
  sessionActiveTab: SessionActiveTab;
};

export const TopologyTabContent = ({
  sessionActiveTab,
}: TopologyTabContentProps): ReactElement => {
  if (sessionActiveTab !== 'topology') return <></>;

  return (
    <>
      <DiagramProvider>
        <SessionDiagramContainer />
      </DiagramProvider>
      <LeftPanelContainer />
    </>
  );
};
